import React from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { ProblemSolution } from './components/ProblemSolution';
import { ProgramFeatures } from './components/ProgramFeatures';
import { Testimonials } from './components/Testimonials';
import { ExpertEndorsement } from './components/ExpertEndorsement';
import { OfferSection } from './components/OfferSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div className="w-full min-h-screen bg-gradient-to-b from-indigo-50 to-white" data-id="element-0">
      {/* Meta Pixel tracking */}
      <MetaPixel data-id="element-1" />
      <Header data-id="element-2" />
      <main className="w-full" data-id="element-3">
        <HeroSection data-id="element-4" />
        <ProblemSolution data-id="element-5" />
        <ProgramFeatures data-id="element-6" />
        <Testimonials data-id="element-7" />
        <ExpertEndorsement data-id="element-8" />
        <OfferSection data-id="element-9" />
        <GuaranteeSection data-id="element-10" />
        <FAQSection data-id="element-11" />
        <FinalCTA data-id="element-12" />
      </main>
      <Footer data-id="element-13" />
    </div>;
}